import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import _Button from "../generic/_Button";
import { dateFormat } from "../../utils/dateHelpers";
import { useFindItem } from "../../hooks/useFindItem";
import { useAuth } from "../../Context/AuthContext";

import Alert from "react-bootstrap/Alert";
import Icon from "../Icon";
import MessageChannelPreview from "../campaigns/multichannel/MessageChannelPreview";

const _ModalConfirmMulti = (props) => {
  const {
    title = "",
    description = "",
    visible,
    onClose,
    onAction,
    isLoading,
    data,
  } = props;
  const auth = useAuth();
  const isAdmin = auth.isAdminRole();
  const {
    campaignName,
    uiddatabase,
    isScheduled,
    dateSend,
    id_customer = null,
    partner = null,
    proghour,

  } = data || {};
  const item = useFindItem(data.listDatabases, "uiddatabase", uiddatabase);
  const mask = useFindItem(data.listMask, "vc_mask", data.mask);
  const info_partner =
    useFindItem(data.partnerList, "uidpartner", partner) || {};
  const customer =
    useFindItem(data.customersList, "idcustomer", parseFloat(id_customer)) ||
    {};
  const _onAction = () => {
    if (onAction) onAction();

    onClose();
  };

  return (
    <Modal show={visible} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <div className="text-xl font-semibold text-gray-600">{title}</div>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="Notice">
          <div className="flex gap-2 items-center justify-start">
            <Icon icon="warning" className="text-yellow-800" />
            <span className="text-md font-normal text-yellow-800">
              {description}
            </span>
          </div>
        </Alert>

        <div className="space-y-4">
          <div className="bg-gray-100 rounded-lg px-4 py-2">
            <div className="font-bold text-lg text-gray-600">
              Datos Generales
            </div>
            <div className="flex justify-between">
              <span className="text-sm font-semibold text-gray-500">
                Campaña:
              </span>
              <span className="text-md font-semibold">
                {campaignName ?? "---"}
              </span>
            </div>
            {isAdmin && (
              <>
                <div className="flex justify-between">
                  <span className="text-sm font-semibold text-gray-500">
                    Carrier:
                  </span>
                  <span className="text-md font-semibold">
                    {info_partner?.name ?? "---"}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-sm font-semibold text-gray-500">
                    Cliente:
                  </span>
                  <span className="text-md font-semibold">
                    {customer?.comercialname ?? "---"}
                  </span>
                </div>
              </>
            )}
            <div className="flex justify-between">
              <span className="text-sm font-semibold text-gray-500">
                Base de datos:
              </span>
              <span className="text-md font-semibold">
                {item?.name ?? "---"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-sm font-semibold text-gray-500">
                Audiencia:
              </span>
              <span className="text-md font-semibold">
                {item?.records ?? "---"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-sm font-semibold text-gray-500">
                Máscara:
              </span>
              <span className="text-md font-semibold">
                {mask?.vc_mask ?? "---"}
              </span>
            </div>
          </div>
          <div className="rounded-lg border px-4 py-2 space-y-3">
            <div className="text-lg font-semibold text-gray-700 border-b border-gray-200 pb-1">
              Mensajes
            </div>

            <div className="grid gap-2">
              <MessageChannelPreview data={data} />
            </div>
          </div>

          <div className="bg-gray-100 rounded-lg px-4 py-2">
            <div className="font-bold text-lg text-gray-600">Programación</div>
            {isScheduled ? (
              <div className="flex justify-between px-4 py-2">
                <div className="flex justify-start gap-1 items-center">
                  <Icon
                    icon="calendar_today"
                    size={24}
                    className={"p-2 rounded-lg bg-white border"}
                  />
                  <div>
                    <span className="font-semibold text-gray-400 text-[10px] flex items-center gap-1">
                      Fecha de Envio
                    </span>
                    <span className="text-md font-semibold">
                      {dateFormat(dateSend, "DD/MM/YYYY") ?? "---"}
                    </span>
                  </div>
                </div>
                <div className="flex justify-start gap-1 items-center">
                  <Icon
                    icon="timer"
                    size={24}
                    className={"p-2 rounded-lg bg-white border"}
                  />
                  <div>
                    <span className="flex items-center gap-1 text-[10px] font-semibold text-gray-400">
                      Hora de Envio
                    </span>
                    <span className="text-md font-semibold">
                      {proghour ?? "---"}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <div className=" bg-gray-100 rounded-lg">
                <span className="text-sm font-semibold text-gray-500">
                  Envió Inmediato (al confirmar)
                </span>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <_Button
          title="Cancelar"
          style="none"
          onClick={onClose}
          loading={isLoading}
          disabled={isLoading}
        />

        <_Button
          title="Guardar"
          onClick={_onAction}
          style="primary"
          loading={isLoading}
          disabled={isLoading}
        />
      </Modal.Footer>
    </Modal>
  );
};
_ModalConfirmMulti.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onAction: PropTypes.func,
  isLoading: PropTypes.bool,
  data: PropTypes.object,
};
export default _ModalConfirmMulti;
